<template>
    <div>
        <banet-modal-confirm
                @confirmNo="confirm(false)"
                @confirmYes="confirm(true)"
                :show="showConfirm"
                :showFooter="true"
                :title="getTranslation('modal_confirm_title')"
                :body="getTranslation('label_confirm_translation_deleting')">
        </banet-modal-confirm>
        <h2>{{ getTranslation('lbl_translation_list_headline') }}</h2>
        <div class="well">
            <div class="row">
                <div class="col-md-2 col-sm-3">
                    <form id="search" style="position: relative; z-index: 0;">
                        <div class="input-group">
                            <span class="input-group-addon glyphicon glyphicon-search" aria-hidden="true"
                                  :title="getTranslation('lbl_search')"></span>
                            <input name="query" v-model="searchQuery"
                                   class="form-control" :placeholder="getTranslation('lbl_search')">
                            <span class="input-group-addon">
                                <button class="btn btn-default" @click.prevent="searchQuery = ''">
                                    <span class="glyphicon glyphicon-remove"></span>
                                </button>
                            </span>
                        </div>
                    </form>
                </div>

                <div class="col-md-10 col-sm-9">
                    <router-link to="/history/translation" tag="button"
                                 class="btn btn-primary pull-right"
                                 :title="getTranslation('lbl_history')">
                        <i class="fa fa-history" aria-hidden="true"></i>
                    </router-link>
                    <router-link to="/translate" activeClass="active" tag="button" class="btn btn-default pull-right">
                        {{ getTranslation('app_lbl_action_translation_create') }}</router-link>
                    <button @click.prevent="saveAll" class="btn btn-default pull-right" style="margin-right:3px;">
                        {{ getTranslation('app_lbl_action_translation_save_all') }}</button>
                </div>
            </div>
        </div>
        <banet-tablegrid
                :data="gridData"
                :columns="gridColumns"
                :filter-key="searchQuery"
                :entryIdField="'key'"
                :actionCol="true"
                :saveBtn="true"
                :cancelBtn="true"
                :deleteBtn="true"
                :actionLink="'translate'"
                :editable="[0,1,1]"
                @update="update"
                @delete="deleteTranslation"
                @cancel="cancelChanges">
        </banet-tablegrid>
    </div>

</template>
<script>
    import { mainEventBus } from '../../../../main';
    import { translationMixin } from '../../../../Banet/mixins/translationMixin.js';
    import BanetTablegrid from '../../../../Banet/components/BanetTablegrid.vue';
    import {alertMixin} from '../../../../Banet/mixins/alertMixin.js';
    import BanetModalConfirm from '../../../../Banet/errorsAndNotifications/BanetModalConfirm.vue';

    export default {
        mixins: [translationMixin, alertMixin],
        components: {
            banetTablegrid: BanetTablegrid,
            banetModalConfirm: BanetModalConfirm
        },
        sockets: {
            translationUpdated: function(){
                this.getList();
            }
        },
        data: function(){
            return {
                searchQuery: '',
                gridColumns: [],
                gridData: [],
                selectedTrans: {}
            }
        },
        created: function(){
//            this.$socket.emit('getTranslationList');
            this.getList();

        },
        computed: {

        },
        watch: {
            translations: function() {
                this.gridColumns = [
                    { label: this.getTranslation('lbl_key'), value: 'key' },
                    { label: this.getTranslation('lbl_en'), value: 'en' },
                    { label: this.getTranslation('lbl_de'), value: 'de' }
                ];
            }
        },
        methods: {
            deleteTranslation: function(transToDel){
                this.selectedTrans = transToDel;
                this.showConfirm = true;
            },
            confirm: function(y){
                this.showConfirm = false;
                if(y){
                    this.deleteConfirmed = true;
                    this.translationDelete(this.selectedTrans);
                    this.selectedTrans = {};
                } else {
                    this.deleteConfirmed = false;
                    this.selectedTrans = {};
                    return false;
                }
            },
            getList: function(){
                this.$http.get('translation/list').then(res => {
                    this.gridData = res.data.obj;
                }, res => {
                    // error callback
                    console.log('Error happend')
                });
            },
            cancelChanges: function(data){
                let transPerKey = this.translationGetByKey(data.key);
                this.$http.get('translation/key/'+ data.key).then(res => {
                    let foundTrans = res.data.obj[0];
                    let grLen = this.gridData.length;
                    for(let i = 0; i <= grLen -1; i++){
                        let k = this.gridData[i].key;
                        if(k === data.key){
                            this.gridData[i].en = foundTrans.en;
                            this.gridData[i].de = foundTrans.de;
                            return;
                        }
                    }
                });
            },
            saveAll: function(){
                this.$http.post('translation/saveall', this.gridData).then(res=>{
                    this.$socket.emit('translationUpdate', this.langParams);
                });
            },
            translationDelete: function(formData){
                const body = JSON.stringify(formData);
                const headers = new Headers({'Content-Type': 'application/json'});
                this.$http.post('translation/delete', body, {headers: headers})
                        .then(res => {
                    this.lastKey = formData.key;
                    this.$socket.emit('translationUpdate', this.langParams);
                    mainEventBus.$emit( 'alert', { type:'success', msg:'app_success_translation_deleted' } );
//                    this.$store.dispatch('setErrors', 'Translation with key ' + this.lastKey + ' deleted.');
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// TranslationList.vue?695dfd5d